import { render, staticRenderFns } from "./OrgListAddNew.vue?vue&type=template&id=69fffcda&"
import script from "./OrgListAddNew.vue?vue&type=script&lang=js&"
export * from "./OrgListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./OrgListAddNew.vue?vue&type=style&index=0&id=69fffcda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports